import { InvoiceType } from "../../../models/DepartmentData/InvoiceType";

export type InvoiceDiscountType = "percentage" | "fixed";

export type InvoiceDiscountParameters = {
  discount_type?: InvoiceDiscountType | null;
  discount_value?: number | null;
};

export function isSpecificationInvoiceType(invoiceType: InvoiceType): boolean {
  return invoiceType === "SPECIFICATION" || invoiceType === "SPECIFICATION_T1";
}

export function getInvoiceDiscountParameters(
  invoiceType: InvoiceType,
  discountType?: InvoiceDiscountType | null,
  discountValue?: number | null
): InvoiceDiscountParameters {
  if (!isSpecificationInvoiceType(invoiceType)) {
    return {};
  }

  return {
    discount_type: discountType ?? null,
    discount_value: discountValue ?? null,
  };
}

export function getDiscountValidationError(
  discountValue: number | null | undefined,
  discountType: InvoiceDiscountType | null | undefined
): string | null {
  if (discountValue === null || discountValue === undefined) {
    return null;
  }

  if (!Number.isFinite(discountValue) || discountValue < 0) {
    return "Discount must be a nonnegative number";
  }

  if (!/^\d+(?:\.\d{1,2})?$/.test(String(discountValue))) {
    return "Discount must have at most two decimal places";
  }

  if (discountValue > 0 && !discountType) {
    return "Select a discount type";
  }

  if (discountType === "percentage" && discountValue > 100) {
    return "Percentage discount cannot exceed 100%";
  }

  return null;
}
